<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard [hideTabs]="true">
          <sb-wizard-tab [active]="true" icon="basicSettings"
                         titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}">
            <form [formGroup]="form" class="wizard__forms px-5 pb-5">
              <h3 class="mb-4">{{'lang.areaEdit.areaCategory' | translate}}</h3>
              <div class="wizard__forms__filterWrapper">
                <div class="wizard__forms__filterWrapper__filterStep">
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('CategorySelect')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue': area?.category}" icon="locationWorld"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="area?.category?.name">{{area?.category?.name}}</h3>
                      <label class="form-label">{{'lang.globals.category' | translate}}</label>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button (click)="changeWizardState('CategorySelect')"
                                 *ngPermissions="permissionService.Permission.area_category_list"
                                 classes="btn-hover-primary m-0 green {{wizardState==='CategorySelect' ? 'btn-hover-primary--active' : ''}}"
                                 container="body" ngbTooltip="{{'lang.globals.select' | translate}}"
                                 placement="top">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span *ngIf="area?.category" class="btn-separator">|</span>
                      <sb-button (click)="sliceCategory()" *ngIf="area?.category"
                                 classes="btn-hover-primary m-0 red" container="body"
                                 ngbTooltip="{{'lang.globals.delete'|translate}}" placement="top">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>
              </div>
              <h3 class="mb-4">{{'lang.globals.relatedCompany' | translate}}</h3>
              <div class="wizard__forms__filterWrapper">
                <div class="wizard__forms__filterWrapper__filterStep">
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('CompanySelect')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue': area?.company}" icon="company"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="area?.company?.name">{{area?.company?.name}}</h3>
                      <label class="form-label">{{'lang.globals.company' | translate}}</label>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button (click)="changeWizardState('CompanySelect')"
                                 *ngPermissions="permissionService.Permission.company_list"
                                 classes="btn-hover-primary m-0 green {{wizardState==='CompanySelect' ? 'btn-hover-primary--active' : ''}}"
                                 container="body" ngbTooltip="{{'lang.globals.selectCompany' | translate}}"
                                 placement="top">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span *ngIf="area?.company" class="btn-separator">|</span>
                      <sb-button (click)="sliceCompany()" *ngIf="area?.company"
                                 classes="btn-hover-primary m-0 red" container="body"
                                 ngbTooltip="{{'lang.globals.delete'|translate}}" placement="top">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>
              </div>
              <h3 class="my-4">{{'lang.areaEdit.areaDetails' | translate}}</h3>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Title">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
                    <input class="form-control" formControlName="Name" id="Title" type="text">
                    <span class="form-text text-muted"
                    >{{'lang.globals.nameDescription' | translate}}</span>
                    <div *ngIf="Name.touched && Name.errors?.required" class="alert alert-danger"
                    >{{'lang.globals.nameWarning' | translate}}</div>
                  </div>
                </div>
              </div>
              <hr class="border-dashed">
              <sb-comp-address-component
                (addressEmitter)="area.address = $event"
                (pointEmitter)="addressPoint = $event" *ngIf="!loading && area?.address"
                [address]="area?.address" [hideCoordinates]="true"
                [noValidation]="true"
                [point]="addressPoint">
              </sb-comp-address-component>
              <div class="wizard__footerActions">
                <sb-button
                  (click)="isInModalContext ? modalNavigation.result(null) : util.returnToNavigation(util.RoutingID.areas)"
                  classes="btn-default btn-lg btn-wide">
                  {{'lang.globals.cancel' | translate}}
                </sb-button>
                <button (click)="submit()" [disabled]="!form.valid || loading" class="btn btn-success btn-wide btn-lg">
                  {{'lang.globals.submit' | translate}}
                </button>
              </div>
            </form>
          </sb-wizard-tab>
          <div class="wizard__aside wizard__aside--half wizard__aside--right p-0 flex-column"
               style="background-color: #f3f6f9;">
            <div *ngIf="wizardState==='CategorySelect'" class="w-100 d-flex px-4 pt-4 justify-content-end">
              <button (click)="changeWizardState('Map')" class="btn btn-hover-primary d-flex align-items-center">
                <sb-icon class="icon-in-btn mr-1" icon="cancel"></sb-icon>
                {{'lang.globals.closeFilterSelection' | translate}}
              </button>
            </div>

            <sb-page-area-categories (selectCategory)="selectCategory($event)" *ngIf="wizardState==='CategorySelect'"
                                     [isInIntegratedContext]="true"
                                     class="w-100 p-4"></sb-page-area-categories>

            <div *ngIf="wizardState==='CompanySelect'" class="w-100 d-flex px-4 pt-4 justify-content-end">
              <button (click)="changeWizardState('Map')" class="btn btn-hover-primary d-flex align-items-center">
                <sb-icon class="icon-in-btn mr-1" icon="cancel"></sb-icon>
                {{'lang.globals.closeFilterSelection' | translate}}
              </button>
            </div>


            <sb-page-companies (selectedCompany)="selectCompany($event)" *ngIf="wizardState==='CompanySelect'"
                               [isInIntegratedContext]="true"
                               class="w-100 p-4"></sb-page-companies>


            <div *ngIf="wizardState==='Map'">
              <sb-polygon-edit-map
                [(lineStrings)]="lineStrings"
                [(points)]="points"
                [(polygons)]="polygons"
                [mapheight]="977"
                [whatIsHere]="true"
              >
              </sb-polygon-edit-map>
            </div>
          </div>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
